<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :hasFilter="true"
      :title="$lang.payment_no_need_list"
      :url="url"
      cardClass="border-0 p-3"
      ref="searchCard"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="showAddModal"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          md="12"
          class="mb-3 pb-3 px-0 border border-top-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-h="center">
            <b-col cols="" md="" class="fs_1rem font-weight-bold pb-md-0 pb-3">
              پرونده شماره
              <span
                @click="goToParvandeh(item)"
                class="text-primary cursor_pointer"
                >{{ pathOr("", ["parvandeh", "parvandeh_number"], item) }}</span
              >
              - {{ pathOr("", ["term", "caption"], item) }} -
              {{ pathOr("", ["term_state", "caption"], item) }}
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="2" class="text-md-left text-center p-0">
          <b-img-lazy
            fluid
            thumbnail
            :onerror="$config.images.onerrorDefaultImg"
            :src="getImage(item)"
            class="bg-white personal_image object__fit--cover"
          />
        </b-col>
        <b-col cols="12" md="10" class="px-0">
          <b-row>
            <b-col cols="12" md="5" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.full_name" />:
              <ProfileBoxPopupWrapper
                :data="item.parvandeh"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
            </b-col>
            <b-col cols="12" md="5" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.term_cost" />:
              <span
                class="text-muted"
                v-text="
                  priceFormat(
                    pathOr(0, ['term', 'cost'], item),
                    pathOr('', ['term', 'currency'], item)
                  )
                "
              />
            </b-col>
            <b-col cols="12" md="2" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.payment_off" />:
              <span
                class="text-muted"
                v-text="`${pathOr(0, ['payment_off_percent'], item)}%`"
              />
            </b-col>
            <b-col
              v-if="pathOr(null, ['description'], item)"
              cols="12"
              md="12"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.description" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['description'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="text-right pt-3 mt-3 px-0 border border-bottom-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-v="center">
            <b-col
              cols="12"
              md="auto"
              class="text-md-left text-center text-muted pb-md-0 pb-3 d-flex align-items-center justify-content-center"
            >
              <div
                v-b-tooltip
                :title="$lang.created_by"
                v-if="
                  pathOr(null, ['created_by'], item) &&
                  pathOr(null, ['created_by'], item) !== getFullName(item)
                "
                class="mr-2"
              >
                <mdicon name="account-edit-outline" size="20" class="mr-1" />
                <span v-text="pathOr('', ['created_by'], item)" />
              </div>
              <div v-b-tooltip :title="$lang.create_time">
                <mdicon name="clock-edit-outline" size="20" class="mr-1" />
                <span
                  v-html="
                    createDateFormat(pathOr([], ['created_at', 'jalali'], item))
                  "
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              md=""
              class="text-md-right text-center text-muted pb-md-0"
            >
              <ExpandButton
                variant="success"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="shield-edit-outline"
                :text="$lang.edit"
                :tooltip="$lang.edit"
                cls="mx-1"
                :condition="isAdmin(permissions)"
                @click="showEditModal(item)"
              />
              <ExpandButton
                variant="danger"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="close"
                :text="$lang.remove"
                :tooltip="$lang.remove"
                cls="mx-1"
                :condition="isAdmin(permissions, ['admin'])"
                @click="showRemoveConfirm(item)"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      hide-header
      hide-footer
      v-model="addEditModal"
    >
      <EditPaymentNoNeed
        v-if="parvandehCode"
        :parvandehCode="parvandehCode"
        :termStateCode="termStateCode"
        @close="closeAddEditModal"
        @getData="getData"
      />
      <AddPaymentNoNeed v-else @close="closeAddEditModal" @getData="getData" />
    </b-modal>
    <Confirm
      :title="confirmData.title"
      :description="confirmData.description"
      v-model="confirmData.show"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      :loadingSpinnerText="$lang.removing_data"
      :loading="confirmData.loading"
      :preventDefault="true"
      @ok="removeItem()"
      @cancel="closeRemoveConfirm()"
    />
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import Confirm from "@/components/base/confirm";
import ExpandButton from "@/components/global/ExpandButton";
import AddPaymentNoNeed from "./AddPaymentNoNeed.vue";
import EditPaymentNoNeed from "./EditPaymentNoNeed.vue";
import { pathOr, includes } from "ramda";
import {
  isAdmin,
  calcPercentage,
  createDateFormat,
  generateApiUrl,
  goToRoute,
  priceFormat,
} from "@/shared/utils";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  name: "search-payment-no-need",
  inject: ["paymentNoNeedRepository"],
  components: {
    SearchCard,
    AddPaymentNoNeed,
    EditPaymentNoNeed,
    Confirm,
    ExpandButton,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      permissions: [],
      addEditModal: false,
      parvandehCode: null,
      termStateCode: null,
      confirmData: {
        show: false,
        loading: false,
        title: this.$lang.remove,
        description: this.$lang.are_you_sure_delete,
        parvandehCode: null,
        termStateCode: null,
      },
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "payment_no_need"]);
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    calcPercentage,
    createDateFormat,
    generateApiUrl,
    priceFormat,
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const name = "parvandeh_by_number";
      const params = { parvandeh_number };
      return goToRoute(name, params);
    },
    getData() {
      this.$refs.searchCard.getItems();
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      return `${pathOr("", ["parvandeh", "person", "name"], item)} ${pathOr(
        "",
        ["parvandeh", "person", "family"],
        item
      )}`;
    },
    showAddModal() {
      this.parvandehCode = null;
      this.termStateCode = null;
      this.addEditModal = true;
    },
    showEditModal(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.termStateCode = pathOr(null, ["term_state", "code"], item);
      this.addEditModal = true;
    },
    closeAddEditModal() {
      this.addEditModal = false;
    },
    showRemoveConfirm(item) {
      this.confirmData.parvandehCode = pathOr(
        null,
        ["parvandeh", "code"],
        item
      );
      this.confirmData.termStateCode = pathOr(
        null,
        ["term_state", "code"],
        item
      );
      this.confirmData.show = true;
    },
    closeRemoveConfirm() {
      this.confirmData.parvandehCode = null;
      this.confirmData.termStateCode = null;
      this.confirmData.show = false;
    },
    getImage(item) {
      const imageKind = pathOr([], ["parvandeh", "person", "img_kind"], item);
      const imageThumb = imageKind.find(
        (x) => pathOr(null, ["type"], x) === "thumb"
      );
      return pathOr(this.$config.images.tinyLogo, ["address"], imageThumb);
    },
    async removeItem() {
      try {
        this.confirmData.loading = true;
        const response = await this.paymentNoNeedRepository.delete(
          this.confirmData.parvandehCode,
          this.confirmData.termStateCode
        );
        this.$notify.success(response.data.message);
        this.closeRemoveConfirm();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
  },
};
</script>
